// Shared tokens + helpers for the jobs module. Date/time formatting lives in
// lib/shop-time.js (Melbourne-local, DST-aware) — shared with the shifts module.
export { formatDateShort, formatTime, formatDateTime } from '../../lib/shop-time.js';

export const TERRACOTTA = '#D97757';

export const JOB_STATUS_LABEL = {
  open: 'Open', in_progress: 'In progress', done: 'Done', cancelled: 'Cancelled',
};

export const JOB_STATUS_PILL = {
  open:        'bg-ink-yellow/[0.12] border-ink-yellow/[0.3] text-ink-yellow',
  in_progress: 'bg-status-info/[0.12] border-status-info/[0.3] text-status-info',
  done:        'bg-status-ok/[0.12] border-status-ok/[0.3] text-status-ok',
  cancelled:   'border-border-strong text-text-tertiary',
};

// due_date is a plain 'YYYY-MM-DD' calendar date, not a timestamp — no
// shop-timezone conversion applies (there's no time-of-day to convert).
// Format with timeZone: 'UTC' so the viewer's own browser zone can't shift
// the displayed day backward/forward from the literal date stored.
export const formatDueDate = (dateStr) => {
  if (!dateStr) return '—';
  const [y, m, d] = dateStr.split('-').map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d));
  return dt.toLocaleDateString('en-AU', { timeZone: 'UTC', day: 'numeric', month: 'short' });
};
